export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXISTOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';
export const RESET_STATE = 'RESET_STATE';
export const FACEBOOK_LOGIN = 'FACEBOOK_LOGIN';

//CARRITO
export const AGREGAR_CARRITO = 'AGREGAR_CARRITO';
export const ERROR_AGREGAR_CARRITO = 'ERROR_AGREGAR_CARRITO';
export const ELIMINAR_CARRITO = 'ELIMINAR_CARRITO';
export const ERROR_ELIMINAR_CARRITO = 'ERROR_ELIMINAR_CARRITO';
export const VER_CARRITO = 'VER_CARRITO';
export const ERROR_VER_CARRITO = 'ERROR_VER_CARRITO';
export const PRECIO_FINAL = 'PRECIO_FINAL';

//PEDIDOS

export const AGREGAR_PEDIDO = 'AGREGAR_PEDIDO';
export const AGREGAR_PEDIDO_ERROR = 'AGREGAR_PEDIDO_ERROR';
export const OBTENER_PEDIDO_CLIENTE = 'OBTENER_PEDIDO_CLIENTE';
export const OBTENER_PEDIDO_CLIENTE_ERROR = 'OBTENER_PEDIDO_CLIENTE_ERROR';
export const ELIMINAR_PEDIDO = 'ELIMINAR_PEDIDO';
export const ELIMINAR_PEDIDO_ERROR = 'ELIMINAR_PEDIDO_ERROR';
export const OBTENER_PEDIDOS_ACTIVO = 'OBTENER_PEDIDOS_ACTIVO';
export const OBTENER_PEDIDOS_ACTIVO_ERROR = 'OBTENER_PEDIDOS_ACTIVO_ERROR';
export const OBTENER_PEDIDOS = 'OBTENER_PEDIDOS';
export const OBTENER_PEDIDOS_ERROR = 'OBTENER_PEDIDOS_ERROR';
export const DESPACHAR_PEDIDO = 'DESPACHAR_PEDIDO';
export const DESPACHAR_PEDIDO_ERROR = 'DESPACHAR_PEDIDO_ERROR';
export const FINALIZAR_PEDIDO = 'FINALIZAR_PEDIDO_ERROR';
export const FINALIZAR_PEDIDO_ERROR = 'FINALIZAR_PEDIDO_ERROR';
export const ELIMINAR_MENU_PEDIDO = 'ELIMINAR_MENU_PEDIDO';
export const ELIMINAR_MENU_PEDIDO_ERROR = 'ELIMINAR_MENU_PEDIDO_ERROR';
export const AGREGAR_MENU_PEDIDO = 'AGREGAR_MENU_PEDIDO';
export const AGREGAR_MENU_PEDIDO_ERROR = 'AGREGAR_MENU_PEDIDO_ERROR';

//MENU
//TIPOS PARA MENU DEL CLIENTE QUE HAYA EN STOCK
export const OBTENER_MENU_STOCK  = 'OBTENER_MENU_STOCK';
export const OBTENER_MENU_STOCK_ERROR = 'OBTENER_MENU_STOCK_ERROR'
export const SUBIR_CARTA = 'SUBIR_CARTA'

//ADMIN
export const OBTENER_MENU_ADMIN = 'OBTENER_MENU_ADMIN_ERROR';
export const OBTENER_MENU_ADMIN_ERROR = 'OBTENER_MENU_ADMIN_ERROR';
export const EDITAR_CARTA = 'EDITAR_CARTA';
export const ELIMINAR_ITEM = 'ELIMINAR_ITEM';
export const ELIMINAR_ITEM_ERROR = 'ELIMINAR_ITEM_ERROR';
export const EDITAR_CARTA_ERROR = 'EDITAR_CARTA_ERROR';
export const AGREGAR_CARTA = 'AGREGAR_CARTA';
export const AGREGAR_CARTA_ERROR = 'AGREGAR_CARTA_ERROR';
export const DIALOG = 'DIALOG';
export const FACTURACION = 'FACTURACION'